import React, { PropTypes, PureComponent } from 'react';
import injectIntl, { intlShape } from 'common/injectIntl';
import LinkWithFlags from 'common/LinkWithFlags';
import styles from './style';

const DEF_PROVIDER_VALUE = 'default';

class ProviderDialog extends PureComponent {
    constructor(props) {
        super(props);
        this.onProviderChange = this.onProviderChange.bind(this);
        this.onContinueClick = this.onContinueClick.bind(this);
        this.state = {
            provider: DEF_PROVIDER_VALUE
        };
    }

    onProviderChange(event) {
        const provider = event.target.value;
        this.setState({
            provider
        });
    }

    onContinueClick(event) {
        const { provider } = this.state;
        const { providers, onContinueClick } = this.props;

        const providerInfo = providers.filter(({ abbreviation }) => abbreviation === provider)[0];
        if (providerInfo && onContinueClick) {
            onContinueClick(event, providerInfo);
        }
    }

    render() {
        const { provider } = this.state;
        const {
            providers,
            branding: {
                name: brandingName,
                logoUrl: brandingLogoUrl
            },
            isAuthenticated,
            authRetry,
            xdomainBlocked,
            onReloadClick,
            messages,
            intl: { formatMessage }
        } = this.props;
        const centeredRowStyle = { ...styles.dialogRow, ...styles.alignCenter };

        const tier1Providers = providers.filter(({ tier }) => tier === 1);
        const tier2Providers = providers.filter(({ tier }) => tier !== 1);

        // build provider list
        const providerOptions = tier1Providers.concat(tier2Providers).map(({ name, abbreviation }) => (
            <option value={abbreviation}>{name}</option>
        ));
        providerOptions.unshift(
            <option value={DEF_PROVIDER_VALUE}>
                {`----- ${formatMessage(messages['feedback.provider.default'])} -----`}
            </option>
        );

        const linkTo = `/mvpd/login?mvpd=${provider}&syndicated=true`;
        const linkTarget = '_blank';

        const xdomainMessage = xdomainBlocked ?
            formatMessage(messages['syndicated.player.dialog.message.xdomain']) :
            '';

        const reloadViewMessage = authRetry ?
            formatMessage(messages['syndicated.player.dialog.message.auth-retry']) :
            formatMessage(messages['syndicated.player.dialog.message.auth-success']);

        return (
            <div className="playback-dialog-container" style={styles.container}>
                <div className="playback-dialog" style={styles.dialog}>
                    <div style={styles.alignCenter}>
                        <img
                            style={styles.logo}
                            src={brandingLogoUrl}
                            alt={brandingName}
                        />
                    </div>
                    {!isAuthenticated && !authRetry ? (
                        <div>
                            <div style={styles.dialogRow}>
                                <p>
                                    {formatMessage(messages['syndicated.player.dialog'])}
                                </p>
                            </div>
                            <div style={styles.dialogRow}>
                                <div style={styles.providerListCol}>
                                    {formatMessage(messages['provider.dialog.title'])}:&nbsp;
                                </div>
                                <div style={styles.providerListCol}>
                                    <select
                                        id="providerList"
                                        defaultValue={provider}
                                        style={styles.providerList}
                                        onChange={this.onProviderChange}
                                    >
                                        {providerOptions}
                                    </select>
                                    <div style={styles.continueBtn}>
                                        {(provider !== DEF_PROVIDER_VALUE) && (
                                            <LinkWithFlags
                                                to={linkTo}
                                                target={linkTarget}
                                                onClick={this.onContinueClick}
                                            >
                                                <button
                                                    className="button med stand-alone"
                                                    style={styles.standAlone}
                                                >
                                                    {formatMessage(messages['syndicated.player.dialog.label.continute'])}
                                                </button>
                                            </LinkWithFlags>
                                        )}
                                    </div>
                                </div>
                                <div style={styles.clear} />
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div style={centeredRowStyle}>
                                <div>{reloadViewMessage}</div><br />
                                <div>{xdomainMessage}</div>
                            </div>
                            {!authRetry && <div style={centeredRowStyle}>
                                <button
                                    className="button lg stand-alone reload"
                                    onClick={onReloadClick}
                                    style={styles.standAlone}
                                >
                                    {formatMessage(messages['syndicated.player.dialog.label.recheck'])}
                                </button>
                            </div>}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

ProviderDialog.propTypes = {
    providers: PropTypes.array.isRequired,
    branding: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    authRetry: PropTypes.bool,
    xdomainBlocked: PropTypes.bool,
    onContinueClick: PropTypes.func.isRequired,
    onReloadClick: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

export default injectIntl(ProviderDialog);



// WEBPACK FOOTER //
// ./app/webapp/syndicated/ProviderDialog/index.js